import { Box, BoxProps } from '@mui/material';
import palette from 'theme/palette';

type Props = BoxProps & {
  count: number;
};

export function CountBadge({ count, sx, ...props }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: count > 9 ? 'auto' : '20px',
        height: '20px',
        borderRadius: count > 9 ? '16px' : '50%',
        color: palette.light.primary.main,
        textAlign: 'center',
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '20px',
        backgroundColor: 'var(--Gray-100, #F2F4F7)',
        px: count > 9 ? '6px' : null,
        ...sx,
      }}
      {...props}
    >
      {count}
    </Box>
  );
}
